export default "__VITE_ASSET__DdcuG677__"